import { LocaleSeparators } from '../../types/LocaleSeparators'
import { isDigitCharCode } from './isDigitCharCode'
import { SeparatorCounts } from './types/separatorCounts'

export const sanitizeNumberStringWithSeparators = (
  input: string,
  separators: LocaleSeparators,
  separatorCounts: SeparatorCounts,
) => {
  const decimalSeparatorLastIndex = input.lastIndexOf(separators.decimalSeparator)
  const isSingleDecimalSeparator = separatorCounts[separators.decimalSeparator] === 1
  let sanitized = ''

  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i)

    const isSingleLastDecimalSeparator =
      isSingleDecimalSeparator && i === decimalSeparatorLastIndex && input[i] === separators.decimalSeparator

    if (isDigitCharCode(charCode) || isSingleLastDecimalSeparator) {
      sanitized += input[i]
    }
  }

  return input[0] === '-' ? `-${sanitized}` : sanitized
}
